import './app.css';



/* is production */
const isProd = process.env.NODE_ENV === 'production';



/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
// const data = require('./js/data.json');



/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', {eventLabel: 'Play'}); */
const analytics = require('universal-ga');

analytics.initialize(meta.trackingID);
analytics.pageview('/index');

if (meta.clientTrackingID.length > 0) {
    analytics.create(meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}

const analyticsEvent = (category, action, options) => {
    analytics.event(category, action, options);

    if (meta.clientTrackingID.length > 0) {
        analytics.name('clientTracker').event(category, action, options);
    }
};

analyticsEvent('Page', 'load', {eventLabel: 'Successfully'});



/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    google: {
        families: ['PT Serif Caption:400,700:cyrillic']
    }
});



/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            VanillaSharing[button.dataset.social](shareOptions);

            analyticsEvent('Share', 'click', {eventLabel: 'Social: ' + button.dataset.social});
        });
    });

}



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    navigator.serviceWorker.register('./sw.js');
}



/* jquery [UNCOMMENT THE LINE BELOW TO USE JQUERY IN JS] */
// window.$ = window.jQuery = require('jquery');



/* nav */
import gumshoe from 'gumshoe';
gumshoe.init();

import SmoothScroll from 'smooth-scroll';
new SmoothScroll('a[href*="#"]', {
    offset: () => {
        const navRect = document.querySelector('.nav').getBoundingClientRect();
        return navRect.height + navRect.top;
    }
});

import Stickyfill from 'stickyfilljs';
Stickyfill.add(document.querySelector('.nav'));



/* events */
const links = [...document.querySelectorAll('.item__link')];
links.forEach(link => {
    link.addEventListener('click', () => {
        analyticsEvent('Link', 'click', {eventLabel: 'Title: ' + link.dataset.title});
    });
});



/* header */
document.querySelector('.header__showinfo').addEventListener('click', () => {
    const body = document.querySelector('body');
    if (body.hasAttribute('data-info')) {
        body.removeAttribute('data-info');
    } else {
        body.setAttribute('data-info', 'show');
        analyticsEvent('Button', 'click', {eventLabel: 'Show Info'});
    }
});

document.querySelector('.header__showshare').addEventListener('click', () => {
    const body = document.querySelector('body');
    if (body.hasAttribute('data-share')) {
        body.removeAttribute('data-share');
    } else {
        body.setAttribute('data-share', 'show');
        analyticsEvent('Button', 'click', {eventLabel: 'Show Share'});
    }
});

document.querySelector('.info__close').addEventListener('click', () => {
    document.querySelector('body').removeAttribute('data-info');
});



// WEBPACK FOOTER //
// ./app.js